/**
 * ML Product Customization Preview (ml-product-6270)
 * - Handles the "Start customizing" button click.
 * - Mirrors the behavior used in the existing ml-custom-now section:
 *   - Prefer clicking the Product Customizer / Zepto button if present.
 *   - Fallback to scrolling to the product form.
 */
(function () {
  'use strict';

  var ROOT_SELECTOR = '.ml-product-6270';
  var START_SELECTOR = '[data-ml-product-6270-start]';
  var PREV_SELECTOR = '[data-mlp6270-prev]';
  var NEXT_SELECTOR = '[data-mlp6270-next]';
  var STATUS_SELECTOR = '[data-mlp6270-status]';

  function isProductSoldOut() {
    if (window.MLProductSoldOutGuard && typeof window.MLProductSoldOutGuard.isCurrentProductSoldOut === 'function') {
      return window.MLProductSoldOutGuard.isCurrentProductSoldOut();
    }

    return !!(document.body && document.body.getAttribute('data-ml-current-product-sold-out') === 'true');
  }

  function showSoldOutNotice() {
    if (window.MLProductSoldOutGuard && typeof window.MLProductSoldOutGuard.focusCurrentNotice === 'function') {
      if (window.MLProductSoldOutGuard.focusCurrentNotice()) return;
    }

    var notice = document.querySelector('[data-ml-sold-out-message]:not([hidden])');
    if (notice && notice.scrollIntoView) {
      notice.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function isUsableButton(button) {
    if (!button) return false;
    if (button.disabled) return false;
    if (button.getAttribute('aria-disabled') === 'true') return false;
    if (button.getAttribute('data-ml-sold-out-disabled') === 'true') return false;
    return true;
  }

  var ENGRAVING_MAP = {
    side_oval: {
      frameEngraving: true,
      options: ["Your pet's name", "Your pet's life span", 'A beautiful message', 'Clip Art'],
    },
    rectangle: {
      frameEngraving: false,
      options: [],
    },
    oval: {
      frameEngraving: true,
      options: ["Your pet's name", "Your pet's life span", 'Clip Art'],
    },
    centered_heart: {
      frameEngraving: true,
      options: ["Your pet's name", "Your pet's life span"],
    },
    fimh_corner: {
      frameEngraving: true,
      options: ["Your pet's name", "Your pet's life span"],
      note:
        "Note: This frame has the saying Forever In My Heart engraved on the left corner. The wording can't be changed, but the font can be.",
    },
    fioh_paws: {
      frameEngraving: true,
      options: ["Your pet's name", "Your pet's life span"],
      note:
        "Note: This frame has the saying Forever In Our Heart engraved on the left side with paws. The wording can't be changed, but the font can be.",
    },
    fimh_hearts: {
      frameEngraving: true,
      options: ["Your pet's name", "Your pet's life span"],
      note:
        "Note: This frame has the saying Forever In My Heart engraved on the left side with hearts. The wording can't be changed, but the font can be.",
    },
    fioh_hearts: {
      frameEngraving: true,
      options: ["Your pet's name", "Your pet's life span"],
      note:
        "Note: This frame has the saying Forever In Our Hearts engraved on the left side with hearts. The wording can't be changed, but the font can be.",
    },
    side_heart: {
      frameEngraving: true,
      options: ["Your pet's name", "Your pet's life span", 'A beautiful message', 'Clip Art'],
    },
    rectangle_base: {
      frameEngraving: true,
      options: ["Your pet's name", "Your pet's life span"],
    },
    centered_square: {
      frameEngraving: true,
      options: ["Your pet's name", 'Clip Art'],
    },
    fioh_corner: {
      frameEngraving: true,
      options: ["Your pet's name", "Your pet's life span"],
      note:
        "Note: This frame has the saying Forever In Our Hearts engraved on the top left corner. The wording can't be changed, but the font can be.",
    },
    side_rectangle: {
      frameEngraving: true,
      options: ["Your pet's name", "Your pet's life span", 'A beautiful message', 'Clip Art'],
    },
    circle: {
      frameEngraving: true,
      options: ["Your pet's name", "Your pet's life span", 'Clip Art'],
    },
    double_oval: {
      frameEngraving: true,
      options: ["Your pet's name", "Your pet's life span"],
    },
    fimh_paws: {
      frameEngraving: true,
      options: ["Your pet's name", "Your pet's life span"],
      note:
        "Note: This frame has the saying Forever In My Heart with paw prints on the left side. The wording can't be changed, but the font can be.",
    },
  };

  function parseSkuKey(sku) {
    if (!sku || typeof sku !== 'string') return '';
    var s = sku.trim().toLowerCase();
    if (!s) return '';
    var parts = s.split('-');
    if (parts.length > 1) return parts.slice(1).join('-');
    return s;
  }

  function setView(root, view) {
    if (!root) return;
    var v = view === 'lid' ? 'lid' : 'frame';
    root.setAttribute('data-mlp6270-view', v);

    var status = root.querySelector(STATUS_SELECTOR);
    if (status) status.textContent = v === 'frame' ? '1 / 2' : '2 / 2';

    // ARIA: only the active slide should be exposed.
    var slides = root.querySelectorAll('[data-mlp6270-slide]');
    slides.forEach(function (el) {
      var isActive = el.getAttribute('data-mlp6270-slide') === v;
      el.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });
  }

  function bindSlider(root) {
    var prev = root.querySelector(PREV_SELECTOR);
    var next = root.querySelector(NEXT_SELECTOR);
    if (!prev && !next) return;

    var toggle = function (dir) {
      var current = root.getAttribute('data-mlp6270-view') || 'frame';
      var nextView = current === 'frame' ? 'lid' : 'frame';
      // Only two states: any direction toggles.
      setView(root, nextView);
    };

    if (prev) {
      prev.addEventListener('click', function (e) {
        e.preventDefault();
        toggle(-1);
      });
    }
    if (next) {
      next.addEventListener('click', function (e) {
        e.preventDefault();
        toggle(1);
      });
    }

    // Keyboard: left/right arrows when focus is within the media.
    var slider = root.querySelector('[data-mlp6270-slider]');
    if (slider) {
      slider.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
          e.preventDefault();
          toggle(e.key === 'ArrowLeft' ? -1 : 1);
        }
      });
      // Make slider focusable for keyboard users.
      if (!slider.hasAttribute('tabindex')) slider.setAttribute('tabindex', '0');
    }
  }

  function updateFrameOptions(root, sku) {
    if (!root) return;
    var key = parseSkuKey(sku || root.getAttribute('data-mlp6270-sku'));
    if (!key) return;

    var data = ENGRAVING_MAP[key];

    var list = root.querySelector('[data-mlp6270-frame-list]');
    var none = root.querySelector('[data-mlp6270-frame-none]');
    var note = root.querySelector('[data-mlp6270-frame-note]');

    if (!list || !none || !note) return;

    if (!data) {
      list.setAttribute('hidden', '');
      none.removeAttribute('hidden');
      none.textContent = '—';
      note.setAttribute('hidden', '');
      note.textContent = '';
      return;
    }

    if (!data.frameEngraving) {
      list.setAttribute('hidden', '');
      none.removeAttribute('hidden');
      none.textContent = 'This frame does not offer frame engraving.';
    } else {
      list.removeAttribute('hidden');
      none.setAttribute('hidden', '');
      list.innerHTML = '';
      (data.options || []).forEach(function (opt) {
        var li = document.createElement('li');
        li.textContent = opt;
        list.appendChild(li);
      });
    }

    if (data.note) {
      note.removeAttribute('hidden');
      note.textContent = data.note;
    } else {
      note.setAttribute('hidden', '');
      note.textContent = '';
    }

    root.setAttribute('data-mlp6270-sku', sku || root.getAttribute('data-mlp6270-sku') || '');
  }

  function tryClickCustomizerButton() {
    var customizerButton =
      document.querySelector('.product-personalizer button') ||
      document.querySelector('button.ptc_button') ||
      document.querySelector('button.pplr-c-button');

    if (!isUsableButton(customizerButton)) return false;

    try {
      customizerButton.click();
      if (customizerButton.scrollIntoView) {
        customizerButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return true;
    } catch (e) {
      return false;
    }
  }

  function fallbackScroll() {
    var productForm = document.querySelector('product-form, form[action*="/cart/add"]');
    if (productForm && productForm.scrollIntoView) {
      productForm.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function bind(root) {
    if (!root || root.dataset.mlp6270Bound === 'true') return;
    root.dataset.mlp6270Bound = 'true';

    // Ensure a sane default view.
    setView(root, root.getAttribute('data-mlp6270-view') || 'frame');

    var btn = root.querySelector(START_SELECTOR);
    if (btn) {
      btn.addEventListener('click', function (evt) {
        evt.preventDefault();

        if (isProductSoldOut()) {
          showSoldOutNotice();
          return;
        }

        var didClick = tryClickCustomizerButton();
        if (!didClick) fallbackScroll();
      });
    }

    bindSlider(root);
    updateFrameOptions(root);

    // React to variant changes (SKU changes with wood type / variants)
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object' && PUB_SUB_EVENTS.variantChange) {
      if (root._mlp6270Unsub) {
        try {
          root._mlp6270Unsub();
        } catch (e) {}
        root._mlp6270Unsub = null;
      }

      root._mlp6270Unsub = subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        if (!event || !event.data || !event.data.variant) return;
        var variant = event.data.variant;
        if (!variant.sku) return;
        updateFrameOptions(root, variant.sku);
      });
    }
  }

  function init(context) {
    var scope = context || document;
    var nodes = scope.querySelectorAll(ROOT_SELECTOR);
    if (!nodes || nodes.length === 0) return;

    nodes.forEach(function (node) {
      bind(node);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });

  // Theme editor support: re-bind when a section is reloaded
  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    init(event.target);
  });
})();
